import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenuModule } from 'primeng/menu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Toast, ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';

import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';

import { AlertService } from './services/alert.service';

import { SecurePipe } from './pipes/secure.pipe';
import { StringJoinPipe } from './pipes/string-join.pipe';
import { HtmlTextPipe } from './pipes/plaintext.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

import { BottomBarComponent } from './components/bottom-bar/bottom-bar.component';
import { AutoFocusModule } from 'primeng/autofocus';
import { AccordionModule } from 'primeng/accordion';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { CardModule } from 'primeng/card';
import { ClickOutsideDirective } from './directives/clickOutside';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OrderListModule } from 'primeng/orderlist';
import { PickListModule } from 'primeng/picklist';
import { AlertHtmlComponent } from './alerts/alert-html/alert-html.component';
import { AddAttachmentModalComponent } from './components/add-attachment/add-attachment-modal/add-attachment-modal.component';
import { AttachmentViewComponent } from './components/attachment-view/attachment-view.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { ChangeLogModalComponent } from './components/change-log-modal/change-log-modal.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';

const components = [
  BottomBarComponent,
  TopBarComponent,
  LoadingIndicatorComponent,
  AlertHtmlComponent,
  AddAttachmentModalComponent,
  AttachmentViewComponent,
  PdfViewerComponent,
  ChangeLogModalComponent,
  SignaturePadComponent,
];

const pipes = [
  SecurePipe,
  StringJoinPipe,
  HtmlTextPipe,
  DurationPipe,
  SafeHtmlPipe,
];

const services = [AlertService, ConfirmationService];

const primeNgModules = [
  MenuModule,
  AutoCompleteModule,
  ToastModule,
  DropdownModule,
  CalendarModule,
  MultiSelectModule,
  DialogModule,
  DropdownModule,
  TableModule,
  TagModule,
  FileUploadModule,
  AutoFocusModule,
  AccordionModule,
  TextareaModule,
  InputTextModule,
  CheckboxModule,
  ListboxModule,
  ColorPickerModule,
  CardModule,
  RadioButtonModule,
  TabViewModule,
  SelectButtonModule,
  OrderListModule,
  PickListModule,
  PdfJsViewerModule,
  TooltipModule,
  ButtonModule,
];

const directives = [ClickOutsideDirective];

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ...primeNgModules],
  declarations: [
    ...components,
    ...pipes,
    ...directives,
  ],
  exports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ...primeNgModules,
    ...components,
    ...pipes,
    ...directives,
  ],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [...services],
    };
  }
}
